export const getQueryParamValue: (queryParams: string, paramName: string) => string = (queryParams, paramName) =>
  new URLSearchParams(queryParams).get(paramName) || ''
